import * as React from 'react';

export default class Largeview extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="files/large-thumbnails/active" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="largeView" stroke="#878787">
              <g id="files-display-icon"></g>
              <path d="M13,1 L14,1 C14.5522847,1 15,1.44771525 15,2 L15,9 C15,9.55228475 14.5522847,10 14,10 L13,10 L13,1 Z" id="selected" stroke="none" fill="#17B9F0"></path>
              <g id="Group" transform="translate(1.000000, 1.000000)" stroke="">
                <path d="M1,11 L12.5108644,11" id="Line" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M0.991829279,13.2857143 L7.50369348,13.2857143" id="Line-Copy-2" strokeLinecap="round" strokeLinejoin="round"></path>
                <rect id="Rectangle-14" x="0.5" y="0.5" width="13" height="8" rx="1"></rect>
              </g>
          </g>
        </g>
      </svg>
    )
  }
}
